import {useCallback} from "react";

import {useMutation} from "@khan/data-gql";
import {Errors, KAError} from "@khan/logging";

import type {khanmigoToolsCreateBlooketV2Variables} from "../graphql/__graphql-types__/khanmigoToolsCreateBlooketV2.ts";
import {CREATE_BLOOKET_MUTATION_V2} from "../graphql/create-blooket-mutation-v2.ts";

export const useCreateBlooketMutation = (): ((
    variables: khanmigoToolsCreateBlooketV2Variables,
) => Promise<void>) => {
    const [mutate] = useMutation(CREATE_BLOOKET_MUTATION_V2);

    return useCallback(
        (variables: khanmigoToolsCreateBlooketV2Variables) => {
            return mutate(variables)
                .then((result) => {
                    // If we have an error status or we got a successful
                    // response but it has an error in it, then we throw an
                    // error.
                    const error =
                        result.status === "error"
                            ? result.error
                            : result.status === "success" &&
                                result.data.createBlooketQuestionSetV2.error
                              ? result.data.createBlooketQuestionSetV2.error
                                    .code
                              : null;

                    if (error) {
                        throw new KAError(
                            "Failed to save blooket",
                            Errors.Internal,
                            {
                                cause: error,
                            },
                        );
                    }
                })
                .catch((error) => {
                    if (error instanceof KAError) {
                        throw error;
                    }

                    throw new KAError(
                        "Failed to save blooket",
                        Errors.Internal,
                    );
                });
        },
        [mutate],
    );
};
